import { Module } from 'vuex';
import { UserInfo } from '../../services/auth.service';

export interface AuthState {
    accessToken: string | null;
    refreshToken: string | null;
    expiresIn: number | null;
    isAuthenticated: boolean;
    userInfo: UserInfo | null;
}

const TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const EXPIRES_IN_KEY = 'expires_in';
const USER_INFO_KEY = 'user_info';

// Load initial state from localStorage
const loadState = (): AuthState => {
    const accessToken = localStorage.getItem(TOKEN_KEY);
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
    const expiresIn = localStorage.getItem(EXPIRES_IN_KEY);
    const userInfoStr = localStorage.getItem(USER_INFO_KEY);
    
    let userInfo: UserInfo | null = null;
    if (userInfoStr) {
        try {
            userInfo = JSON.parse(userInfoStr);
        } catch (e) {
            console.error('Failed to parse user info from localStorage', e);
        }
    }
    
    return {
        accessToken,
        refreshToken,
        expiresIn: expiresIn ? parseInt(expiresIn, 10) : null,
        isAuthenticated: !!accessToken,
        userInfo
    };
};

export const authModule: Module<AuthState, any> = {
    namespaced: true,
    state: loadState(),
    
    mutations: {
        SET_AUTH(state, payload: { accessToken: string; refreshToken: string; expiresIn: number }) {
            state.accessToken = payload.accessToken;
            state.refreshToken = payload.refreshToken;
            state.expiresIn = payload.expiresIn;
            state.isAuthenticated = true;
            
            // Persist to localStorage
            localStorage.setItem(TOKEN_KEY, payload.accessToken);
            localStorage.setItem(REFRESH_TOKEN_KEY, payload.refreshToken);
            localStorage.setItem(EXPIRES_IN_KEY, payload.expiresIn.toString());
        },
        
        UPDATE_ACCESS_TOKEN(state, payload: { accessToken: string; expiresIn: number }) {
            state.accessToken = payload.accessToken;
            state.expiresIn = payload.expiresIn;
            state.isAuthenticated = true;
            
            localStorage.setItem(TOKEN_KEY, payload.accessToken);
            localStorage.setItem(EXPIRES_IN_KEY, payload.expiresIn.toString());
        },
        
        SET_USER_INFO(state, userInfo: UserInfo) {
            state.userInfo = userInfo;
            localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
        },
        
        CLEAR_AUTH(state) {
            state.accessToken = null;
            state.refreshToken = null;
            state.expiresIn = null;
            state.isAuthenticated = false;
            state.userInfo = null;
            
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(REFRESH_TOKEN_KEY);
            localStorage.removeItem(EXPIRES_IN_KEY);
            localStorage.removeItem(USER_INFO_KEY);
        }
    },
    
    actions: {
        login({ commit }, payload: { accessToken: string; refreshToken: string; expiresIn: number }) {
            commit('SET_AUTH', payload);
        },
        
        updateToken({ commit }, payload: { accessToken: string; expiresIn: number }) {
            commit('UPDATE_ACCESS_TOKEN', payload);
        },
        
        setUserInfo({ commit }, userInfo: UserInfo) {
            commit('SET_USER_INFO', userInfo);
        },
        
        logout({ commit }) {
            commit('CLEAR_AUTH');
        }
    },
    
    getters: {
        isAuthenticated: (state) => state.isAuthenticated,
        accessToken: (state) => state.accessToken,
        refreshToken: (state) => state.refreshToken,
        userInfo: (state) => state.userInfo,
        customerLogo: (state) => state.userInfo && state.userInfo && state.userInfo.customer_logo || null
    }
};














